import { Fragment } from 'react';

export default function Table({ rows, columns, actions }) {
  return (
    <div className="flex flex-col">
      <div className="my-2 overflow-x-auto sm:-mx-6">
        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  {rows.map((r) => (
                    <Fragment key={r.field}>
                      {!r.hidden && (
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          {r.title}
                        </th>
                      )}
                    </Fragment>
                  ))}
                  {actions &&
                    actions.map((a) => (
                      <th
                        key={a.name}
                        scope="col"
                        className="relative px-6 py-3"
                      >
                        <span className="sr-only">{a.name}</span>
                      </th>
                    ))}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {columns.length > 0 ? (
                  columns.map((c) => (
                    <tr key={c?._id}>
                      {rows
                        .filter((r) => !r.hidden)
                        .map((r) => (
                          <td
                            key={r.field}
                            className="px-6 py-4 whitespace-nowrap"
                          >
                            <div className="">
                              <div className="">
                                <div className="text-sm font-medium text-gray-600">
                                  {c?.[r?.field]}
                                </div>
                              </div>
                            </div>
                          </td>
                        ))}
                      {actions &&
                        actions.map((a) => (
                          <td
                            key={a.name}
                            className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"
                          >
                            <button
                              onClick={() => a.handleClick(c)}
                              className={`text-${a.color}-500 hover:text-${a.color}-900`}
                            >
                              {a.name}
                            </button>
                          </td>
                        ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={rows.filter((r) => !r.hidden).length}
                      className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium"
                    >
                      No data
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
